const CustomSearch = (value, search, item)=>{
    return Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search.toString().toLowerCase()))
}

export default CustomSearch;